import type { UseGpxRemoteSelectOptions } from './types'

export const DEFAULT_REMOTE_SELECT_ITEM_SIZE = 38

export function pageCacheKey(query: string, page: number) {
  return `${query}\0${page}`
}

export function pageForIndex(index: number, perPage: number) {
  return Math.floor(index / perPage) + 1
}

export function pagesForRange(
  first: number,
  last: number,
  perPage: number,
  total: number,
) {
  const safeLast = Math.max(last, first + 1)
  const startPage = pageForIndex(first, perPage)
  const endPage = pageForIndex(Math.max(safeLast - 1, first), perPage)
  const maxPage = total > 0 ? Math.ceil(total / perPage) : endPage
  const pages: number[] = []
  for (let page = startPage; page <= Math.min(endPage, maxPage); page += 1) {
    pages.push(page)
  }
  return pages
}

export function rangeIsLoaded<T>(
  items: Array<T | undefined>,
  first: number,
  last: number,
) {
  if (items.length === 0 || last <= first) {
    return false
  }
  for (let i = first; i < last; i += 1) {
    if (items[i] == null) {
      return false
    }
  }
  return true
}

export function isRemoteSelectEnabled(
  enabled: UseGpxRemoteSelectOptions<unknown>['enabled'],
) {
  if (enabled == null) {
    return true
  }
  return typeof enabled === 'boolean' ? enabled : enabled.value
}
